import { FlowCardLoading } from '@components/FlowCard'
import { ActivateExistingCard } from '@components/RouteComponents'
import {
  orgDetailsQueryOptions,
  orgSettingsQueryOptions,
} from '@src/queryOptions/org'
import { createFileRoute } from '@tanstack/react-router'

import { ensureUserTermsQueryData } from '../-utils/ensureUserTermsQueryData'

export const Route = createFileRoute('/_initialized/activateExistingCard')({
  loader: async ({ context }) => {
    const { queryClient, store } = context
    const storeState = store.getState().onboarding
    const orgDetails = await queryClient.ensureQueryData(
      orgDetailsQueryOptions({ organizationId: storeState.orgId })
    )
    const location_id = orgDetails?.data.default_location_id
    return Promise.all([
      context.queryClient.ensureQueryData(orgSettingsQueryOptions(location_id)),
      ensureUserTermsQueryData(context),
    ])
  },
  component: ActivateExistingCard,
  pendingComponent: FlowCardLoading,
})
